module.exports = __webpack_public_path__ + "web/img/img8.a0433fc1.png";